/* ============================================================
   Quick-add cart icon for product grid cards
   - Replaces the hover/tap "Add to cart" button that used to
     appear below the image on collection pages.
   - Adds a small transparent cart icon to each product card.
   - Simple products (1 variant): triggers the existing (hidden)
     form submit so the theme's AJAX cart handles the add.
   - Products with multiple variants: navigates to the product
     page so the customer can pick options.
   - Sold out products: no icon.
   ============================================================ */
/* Zoom/expand button — open the current product image(s) in a fancybox
   lightbox. The theme's default handler assumes elevateZoom was set up
   (which only happens when the product has multiple images) so it
   silently errors out on single-image products. This handler runs in the
   capture phase, stops the theme's handler, and works for BOTH cases:
   - Multi-image products: builds a gallery from product.media thumbnails
   - Single-image products: opens just the current main image fullscreen */
(function () {
    'use strict';

    function openLightbox(e) {
        if (!e.target) return;
        var btn = e.target.closest('#velaViewImage');
        if (!btn) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        // Need jQuery + fancybox (both bundled with the theme)
        if (!window.jQuery || !window.jQuery.fancybox) return;
        var $ = window.jQuery;

        // Try to assemble a gallery from thumbnails, fall back to main image
        var gallery = [];
        document.querySelectorAll(
            '#productThumbs .product-single__thumbnail'
        ).forEach(function (a) {
            var href = a.getAttribute('href') || a.getAttribute('data-zoom-image');
            if (href) gallery.push({ src: href });
        });

        if (gallery.length === 0) {
            var main = document.getElementById('ProductPhotoImg');
            var url = btn.getAttribute('data-master-url') ||
                      (main && (main.getAttribute('data-zoom-image') || main.src));
            if (url) gallery.push({ src: url });
        }

        if (gallery.length === 0) return;

        try {
            $.fancybox.open(gallery);
        } catch (err) {
            // Graceful fallback: open the first image in a new tab
            window.open(gallery[0].src, '_blank');
        }
    }

    document.addEventListener('click', openLightbox, true);
})();

/* Destroy Owl Carousel on product thumbnails at desktop sizes so our
   CSS-driven vertical thumbnail layout can take over. Owl applies inline
   `style="width: Npx"` to each item which beats external CSS specificity —
   destroying Owl here is the only reliable way to reset those widths. */
(function () {
    'use strict';

    function stripOwl() {
        if (window.innerWidth < 768) return;
        var wrap = document.getElementById('productThumbs');
        if (!wrap) return;
        var thumbs = wrap.querySelector('.owl-carousel, .product-single__thumbnails');
        if (!thumbs) return;
        try {
            if (window.jQuery) {
                var $t = jQuery(thumbs);
                if ($t.hasClass('owl-loaded')) {
                    $t.trigger('destroy.owl.carousel');
                }
                // Destroy slick if present too
                if ($t.hasClass('slick-initialized')) {
                    $t.slick('unslick');
                }
            }
        } catch (e) { /* ignore */ }
        // Remove inline styles Owl/Slick leave behind
        thumbs.removeAttribute('style');
        wrap.querySelectorAll('[style]').forEach(function (el) {
            el.removeAttribute('style');
        });
        // Strip carousel classes so our CSS takes over cleanly
        thumbs.classList.remove(
            'owl-carousel', 'owl-loaded', 'owl-drag',
            'owl-hidden', 'owl-refreshed',
            'slick-slider', 'slick-initialized', 'slick-dotted'
        );
        // Remove any leftover nav/arrow/dot elements that Owl or Slick injected
        wrap.querySelectorAll(
            '.owl-nav, .owl-dots, .slick-arrow, .slick-prev, ' +
            '.slick-next, .slick-dots, [class*="owl-prev"], [class*="owl-next"]'
        ).forEach(function (el) {
            el.parentNode && el.parentNode.removeChild(el);
        });
    }

    // Run after Owl has had a chance to init (it fires on $(window).load in vela.js)
    window.addEventListener('load', function () {
        // Small delay to make sure Owl has fully initialized first
        setTimeout(stripOwl, 50);
    });
    // Redo on resize (user rotating device / devtools)
    var t;
    window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(stripOwl, 150);
    });
})();

/* Fix: product page thumbnail click should swap the main image.
   The theme's vela.js click handler updates data-zoom-image but forgets
   to update the <img>'s actual src — so clicking a thumbnail did nothing
   visible. We bind our own delegated handler (capture phase) that does it. */
(function () {
    'use strict';

    document.addEventListener('click', function (e) {
        var thumb = e.target.closest('.product-single__thumbnail');
        if (!thumb) return;

        var stype = thumb.getAttribute('data-stype');
        if (stype && stype !== 'image') return; // videos/models handled by vela.js

        var newSrc = thumb.getAttribute('data-image');
        if (!newSrc) return;

        var mainImg = document.getElementById('ProductPhotoImg');
        if (!mainImg) return;
        if (mainImg.src === newSrc) return; // already the same image

        // Preload into memory first so we only swap once the file is ready
        // (avoids a white flash while the new image loads).
        var pre = new Image();
        mainImg.style.opacity = '0.4';
        mainImg.style.transition = 'opacity 0.15s ease';

        pre.onload = function () {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = newSrc;
            mainImg.style.opacity = '1';
        };
        pre.onerror = function () {
            mainImg.style.opacity = '1';
        };
        pre.src = newSrc;
    }, true);
})();

(function () {
    'use strict';

    var ICON_SVG =
        '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path>' +
            '<path d="M3 6h18"></path>' +
            '<path d="M16 10a4 4 0 0 1-8 0"></path>' +
        '</svg>';

    function inject(block) {
        if (!block || block.querySelector('.quickAddIcon')) return;

        var imgWrap = block.querySelector('.proHImage');
        if (!imgWrap) return;

        var form = block.querySelector('form.formAddToCart');
        if (!form) return;

        var submitEl = form.querySelector('.btnAddToCart');
        if (!submitEl) return;

        // Skip sold-out products
        if (submitEl.classList.contains('disabled') || submitEl.disabled) return;

        // If the theme rendered the action as an <a> link, the product
        // has multiple variants → we should navigate to the product page.
        var isVariantProduct = submitEl.tagName === 'A';
        var productUrl = isVariantProduct ? submitEl.getAttribute('href') : null;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quickAddIcon';
        btn.setAttribute(
            'aria-label',
            isVariantProduct ? 'Vælg varianter' : 'Føj til kurv'
        );
        btn.innerHTML = ICON_SVG;

        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (isVariantProduct) {
                if (productUrl) window.location.href = productUrl;
                return;
            }

            // Brief visual feedback
            btn.classList.add('is-loading');

            // Trigger the theme's existing (now hidden) submit button.
            // This preserves any AJAX-cart behaviour (fly-to-cart,
            // cart drawer, event hooks, etc.) wired up in vela.js.
            try {
                submitEl.click();
            } catch (err) {
                // Fallback: plain form submit
                form.submit();
            }

            setTimeout(function () {
                btn.classList.remove('is-loading');
                btn.classList.add('is-added');
                setTimeout(function () {
                    btn.classList.remove('is-added');
                }, 1200);
            }, 400);
        });

        imgWrap.appendChild(btn);
    }

    /* Inject in batches during idle time so injecting 100+ buttons
       doesn't block initial paint on large collection pages. */
    function injectAllDeferred(root) {
        var blocks = Array.prototype.slice.call(
            (root || document).querySelectorAll('.velaProBlock')
        );
        if (blocks.length === 0) return;

        var runNext = function () {
            var batch = blocks.splice(0, 12);
            batch.forEach(inject);
            if (blocks.length === 0) return;

            if (window.requestIdleCallback) {
                window.requestIdleCallback(runNext, { timeout: 500 });
            } else {
                setTimeout(runNext, 16);
            }
        };
        // First batch — prioritize visible products so users see icons fast
        runNext();
    }

    function ready(fn) {
        if (document.readyState !== 'loading') fn();
        else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
        injectAllDeferred(document);

        // Re-scan when new product cards are inserted (load-more / ajax filter)
        if ('MutationObserver' in window) {
            var mo = new MutationObserver(function (mutations) {
                for (var i = 0; i < mutations.length; i++) {
                    var m = mutations[i];
                    for (var j = 0; j < m.addedNodes.length; j++) {
                        var n = m.addedNodes[j];
                        if (n.nodeType !== 1) continue;
                        if (n.classList && n.classList.contains('velaProBlock')) {
                            inject(n);
                        } else {
                            injectAllDeferred(n);
                        }
                    }
                }
            });
            mo.observe(document.body, { childList: true, subtree: true });
        }
    });
})();
